import Dialog from '#lib/components/dialog.jsx';
import { SparklesIcon } from '@heroicons/react/24/outline/index.js';
import { Icon } from '@iconify-icon/react';

export default function MiniPopUp(props) {
    const { isOpen, onClose, type, addPlan } = props;

    const handleAddPlan = (planType) => {
        const confirm = window.confirm(_t.edit.places.customPlanConfirm());
        if (!confirm) return;
        addPlan(planType);
        onClose();
    };

    return (
        <Dialog isOpen={isOpen} onClose={onClose}>
            <Dialog.Panel className="flex flex-col space-y-4 px-4 py-2 w-[300px]">
                <div className="pr-4">
                    <Dialog.CloseButton />
                    <b>{_t.edit.places.createPlanText()}</b>
                    <p className="pr-2 mt-1 text-sm break-all">
                        {type === 'info' ? _t.edit.places.createPlanDescription() : _t.edit.places.choosePlanType()}
                    </p>
                </div>
                {type === 'info' ? (
                    <div className="flex justify-center">
                        <div
                            className="flex flex-col gap-3 items-center w-24 px-2 py-4 bg-slate-100 border border-slate-200 rounded-lg cursor-pointer hover:bg-primary-50 hover:border-primary-400"
                            onClick={() => handleAddPlan('info')}
                        >
                            <Icon
                                icon="material-symbols:info-outline-rounded"
                                width="1.2rem"
                                height="1.2rem"
                                className="pt-[3px]"
                            />
                            <p className="text-xs">{_t.edit.planner.info()}</p>
                        </div>
                    </div>
                ) : (
                    <div className="flex justify-between gap-x-6">
                        <div
                            className="flex flex-col gap-3 items-center w-24 px-2 py-4 bg-slate-100 border border-slate-200 rounded-lg cursor-pointer hover:bg-primary-50 hover:border-primary-400"
                            onClick={() => handleAddPlan('custom')}
                        >
                            <Icon
                                icon="material-symbols:inbox-customize-outline-rounded"
                                width="1.2rem"
                                height="1.2rem"
                                className="pt-[3px]"
                            />
                            <p className="text-xs">{_t.edit.planner.custom()}</p>
                        </div>
                        <div
                            className="flex flex-col gap-3 items-center w-24 px-2 py-4 bg-slate-100 border border-slate-200 rounded-lg cursor-pointer hover:bg-primary-50 hover:border-primary-400"
                            onClick={() => handleAddPlan('suggestion')}
                        >
                            <SparklesIcon width={20} height={20} />
                            <p className="text-xs">{_t.edit.planner.suggestion()}</p>
                        </div>
                    </div>
                )}
            </Dialog.Panel>
        </Dialog>
    );
}
